import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Guard from 'components/access-control/rbac/Guard';
import { PRIV } from 'components/access-control/rbac/privileges';
import React from 'react'
import { Button, Card, Dropdown } from 'react-bootstrap';

export const HeaderSection = ({ navigate, status, id, setShowModal, setActionType  }) => {

  const handleAction = (action) => {
    setActionType(action);
    setShowModal(true);
  };

  // primary logic
  const canTakePrimaryAction =
    ["INQUIRE", "IN_REVIEW", "MORE_INFO", "PENDING"]
      .includes(status);

  // secondary workflow actions
  const canShowMoreActions =
    ["INQUIRE", "IN_REVIEW", "MORE_INFO", "PAUSE", "PENDING"]
      .includes(status);

  const canIssueCredit = status === "APPROVED" || status === "CREDIT_ISSUED";

  return (
    <Card className="mb-4 shadow-none mt-3 rounded border-1">
      <Card.Body className="d-flex align-items-center py-3 px-4 flex-wrap">
        {/* Left side: Back button */}
        <div className="d-flex align-items-center" style={{ minWidth: 90 }}>
          <Button
            type="button"
            onClick={() => navigate("/olitask/donations/credit-applications")}
            size="sm"
            aria-label="Go back"
            variant="outline-success"
          >
            <span style={{ fontSize: "1.3em", lineHeight: 1 }}>←</span> Back
          </Button>
        </div>

        {/* Center: Title */}
        <div className="px-3">
          <h4 className="mb-0 fw-semibold text-base">
            Credit application details
          </h4>
        </div>

        {/* Right side: Action buttons */}
        <div className="flex-1 d-flex mt-3 mt-sm-0 align-items-center justify-content-sm-end gap-2">
          {/* primary actions */}
          {canTakePrimaryAction && (
            <>
              {/* approve */}
              <Guard privilege={PRIV.APPROVE_APPLICATIONS}>
                <Button
                  variant="success"
                  size="sm"
                  onClick={() => handleAction("APPROVE")}
                >
                  Approve
                  <FontAwesomeIcon icon="check" className="ms-1" />
                </Button>
              </Guard>

              {/* decline */}
              <Guard privilege={PRIV.APPROVE_APPLICATIONS}>
                <Button
                  variant="danger"
                  size="sm"
                  onClick={() => handleAction("DENY")}
                >
                  Decline
                  <FontAwesomeIcon icon="times" className="ms-1" />
                </Button>
              </Guard>

              {/* cancel */}
              <Guard privilege={PRIV.APPROVE_APPLICATIONS}>
                <Button
                  variant="secondary"
                  size="sm"
                  onClick={() => handleAction("CANCEL")}
                >
                  Cancel
                  <FontAwesomeIcon icon="ban" className="ms-1" />
                </Button>
              </Guard>
            </>
          )}

          {/* issue credit */}
          {canIssueCredit && (
            <Guard privilege={PRIV.ISSUE_CREDIT}>
              <Button
                variant="success"
                size="sm"
                onClick={() =>
                  navigate(
                    `/olitask/donations/credit-application/${id}/issue-credit`
                  )
                }
              >
                {status === "CREDIT_ISSUED" ? "Issue More Credit":"Issue Credit"}
                <FontAwesomeIcon icon="check" className="ms-1" />
              </Button>
            </Guard>
          )}

          {/* more options */}
          {canShowMoreActions && (
            <Guard privilege={PRIV.APPROVE_APPLICATIONS}>
              <Dropdown>
                <Dropdown.Toggle
                  variant="outline-secondary"
                  size="sm"
                >
                  More Actions
                </Dropdown.Toggle>

                <Dropdown.Menu>

                  {status !== "INQUIRE" && (
                    <Dropdown.Item
                      onClick={() =>
                        handleAction("INQUIRE")
                      }
                    >
                      Make an Inquiry
                    </Dropdown.Item>
                  )}

                  {status !== "PAUSE" && (
                    <Dropdown.Item
                      onClick={() =>
                        handleAction("PAUSE")
                      }
                    >
                      Pause Application
                    </Dropdown.Item>
                  )}

                  <Dropdown.Divider />

                  {status !== "MORE_INFO" && (
                    <Dropdown.Item
                      onClick={() =>
                        handleAction("MORE_INFO")
                      }
                    >
                      Request More Info
                    </Dropdown.Item>
                  )}

                </Dropdown.Menu>
              </Dropdown>
            </Guard>
          )}
        </div>
      </Card.Body>
    </Card>
  );
};
